import { Directive, ElementRef, AfterContentChecked } from '@angular/core';

@Directive({
  selector: '[ecaAutoFocus]'
})
export class EcaAutoFocusDirective implements AfterContentChecked {
  private element: HTMLElement;
  private hasFocused = false;

  constructor($element: ElementRef) {
    this.element = $element.nativeElement;
  }

  ngAfterContentChecked() {
    this.giveFocus();
  }

  giveFocus() {
    if (!this.hasFocused) {
      this.element.focus();
      this.hasFocused = true;
    }
  }
}
